<div
  class="company-body"
  [class.company-body--embedded-mobile]="embeddedInAccountAdmin && isSmallScreenLayout"
  (focusin)="scrollFormFieldIntoView($event)">
<form [formGroup]="companyForm" *ngIf="companyForm" class="company-form">
  <ion-item>
    <ion-input
      class="ion-text-right"
      formControlName="name"
      [label]="'COMPANY.COMPANY_NAME' | translate"
      [labelPlacement]="fieldLabelPlacement"
      [placeholder]="'COMPANY.COMPANY_NAME_PLACEHOLDER' | translate">
    </ion-input>
  </ion-item>

  <ion-item class="company-owner-item" [class.company-owner-item--stacked]="fieldLabelPlacement === 'stacked'">
    <label>{{ 'COMPANY.OWNER' | translate }}</label>
    <ion-grid class="first-and-last">
      <ion-row class="owner-inputs">
        <ion-col size="12" size-md="6">
          <ion-input 
            class="ion-text-right"
            formControlName="first_name"
            [label]="'COMPANY.FIRST_NAME' | translate"
            [labelPlacement]="fieldLabelPlacement"
            [placeholder]="'COMPANY.FIRST_NAME_PLACEHOLDER' | translate">
          </ion-input>
        </ion-col>
        <ion-col size="12" size-md="6">
          <ion-input
            formControlName="last_name"
            [label]="'COMPANY.LAST_NAME' | translate"
            [labelPlacement]="fieldLabelPlacement"
            [placeholder]="'COMPANY.LAST_NAME_PLACEHOLDER' | translate">
          </ion-input>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <section class="company-collapsible-section">
    <h2
      class="company-section-title collapsible-section-toggle"
      (click)="toggleMailingAddressSection()"
      role="button"
      tabindex="0"
      (keydown.enter)="toggleMailingAddressSection()"
      (keydown.space)="toggleMailingAddressSection(); $event.preventDefault()"
      [attr.aria-expanded]="showMailingAddressSection">
      <span class="company-section-heading">
        {{ 'COMPANY.MAILING_ADDRESS' | translate }}
        <span class="company-section-summary" *ngIf="!showMailingAddressSection">{{ mailingAddressSummary }}</span>
      </span>
      <ion-icon [name]="showMailingAddressSection ? 'chevron-up-outline' : 'chevron-down-outline'" aria-hidden="true"></ion-icon>
    </h2>
    <div *ngIf="showMailingAddressSection" class="company-section-body">
      <ion-item>
        <label>{{ 'COMPANY.COUNTRY' | translate }}</label>
        <select formControlName="country" class="small" [attr.aria-label]="'COMPANY.COUNTRY' | translate">
          <option *ngFor="let c of countries" [value]="c.code">{{ c.name || ('COMPANY.COUNTRY' | translate) }}</option>
        </select>
      </ion-item>

      <ion-item>
        <ion-input
          class="ion-text-right"
          formControlName="line_one"
          [label]="'COMPANY.LINE_1' | translate"
          [labelPlacement]="fieldLabelPlacement"
          [placeholder]="'COMPANY.ADDRESS_LINE_1' | translate">
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          class="ion-text-right"
          formControlName="line_two"
          [label]="'COMPANY.LINE_2' | translate"
          [labelPlacement]="fieldLabelPlacement"
          [placeholder]="'COMPANY.ADDRESS_LINE_2' | translate">
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          class="ion-text-right"
          formControlName="city"
          [label]="'COMPANY.CITY' | translate"
          [labelPlacement]="fieldLabelPlacement"
          [placeholder]="'COMPANY.CITY_PLACEHOLDER' | translate">
        </ion-input>
      </ion-item>

      <ion-item *ngIf="isUS()">
        <label>{{ 'COMPANY.STATE' | translate }}</label>
        <select formControlName="state" class="small" [attr.aria-label]="'COMPANY.STATE' | translate">
          <option *ngFor="let st of getStates()" [value]="st.abbreviation">{{ st.name }} ({{ st.abbreviation }})</option>
        </select>
      </ion-item>
      <ion-item *ngIf="!isUS()">
        <ion-input
          class="ion-text-right"
          formControlName="state"
          [label]="'COMPANY.STATE_PROVINCE_REGION' | translate"
          [labelPlacement]="fieldLabelPlacement"
          [placeholder]="'COMPANY.STATE_PROVINCE_REGION' | translate">
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          class="ion-text-right"
          formControlName="postal_code"
          [label]="(isUS() ? ('COMPANY.ZIP_CODE' | translate) : ('COMPANY.POSTAL_CODE' | translate))"
          [labelPlacement]="fieldLabelPlacement"
          [placeholder]="'COMPANY.POSTAL_CODE_PLACEHOLDER' | translate">
        </ion-input>
      </ion-item>
    </div>
  </section>
</form>

<p class="company-switch-account-hint ion-padding-horizontal ion-text-wrap"
  [class.company-switch-account-hint--embedded-mobile]="embeddedInAccountAdmin && isSmallScreenLayout"
  role="note">
  <span class="company-switch-account-hint-prefix">{{ 'COMPANY.SWITCH_ACCOUNT_HINT_PREFIX' | translate }}</span><button
    type="button"
    class="company-switch-account-hint-link"
    (click)="goToSwitchAccounts()"
  >{{ 'COMPANY.SWITCH_ACCOUNT_HINT_LINK' | translate }}</button>
</p>
</div>

<ion-row class="ion-justify-content-end ion-padding-end company-submit-row"
  [class.company-submit-row--embedded-mobile]="embeddedInAccountAdmin && isSmallScreenLayout">
  <ion-button type="submit"
    [disabled]="!isValid() || !canAdminister"
    (click)="save()" *ngIf="!updatePending">{{ 'COMPANY.SUBMIT' | translate }}</ion-button>
  <div *ngIf="updatePending" class="submitpending">
    <ion-spinner name='bubbles'></ion-spinner>
    <span>{{ 'COMPANY.UPDATING' | translate }}</span>
  </div>
</ion-row>
